import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { catchError, retry, map, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { AgencyMasterProperties, AgencyBaseDataProperties, Agencies_BranchesProperties, AgencyBranchCreditProperties, ManagerDetailsProperties, ReportTypesAgency, agencyBackFromServerProperties, CustomerCodes, AgencyListBaseData, CreditLimitChecking, AgenciesForManagers, BackSystemCreditLimitProperties, BackSystemCreditRequest, AddNewManagers } from '../Models/AgencyMasterProperties';
import { B2BActiveBranches, CustomerSaleOrder, ActiveAgencies, ParentUsers, Agency_Branches } from '../Models/ActiveClasses';
import { AgencyRightsProperties, ReturnToFrontPropertiesforAgency } from '../Models/AgencyRightsProperties';
import { AgencySupplierRightsdata } from '../Models/SuppliersProperties';
import { LoginUserRights, UserStatisticsProps } from '../Models/UsersProperties';
import { Agency_BranchGroupsProperties } from '../Models/Agency_BranchGroupsProperties';
import { ManagerProperties } from '../Models/ManagerProperties';
import { BackSystemOfficeProperties, branchBackFromServerProperties, BackSystemAllList, ParentBackSystemCompanies } from '../Models/BranchInformationProperties';
import { CitiesWithManagerCode, Countries } from '../Models/Countries';
import { CompanyMasterProperties } from '../Models/CompanyMasterProperties';


@Injectable({
  providedIn: 'root'
})
export class AgencyService {
  baseUrl = environment.baseUrl;
  backSystemUrl = environment.backSystemBaseUrl;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  }
  constructor(private http: HttpClient) { }

  CreateAgency(agencyObj): Observable<agencyBackFromServerProperties> {
    return this.http.post<agencyBackFromServerProperties>(this.baseUrl + '/AgencyMaster/CreateAgency', agencyObj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  UpdateAgency(agencyObj): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/AgencyMaster/UpdateAgency', agencyObj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  CreateAdminUser(userObj): Observable<number> {
    return this.http.post<number>(this.baseUrl + '/Users/CreateUser', userObj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  UpdateAdminUser(userObj): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/AgencyMaster/UpdateAgencyUserAdminRights', userObj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  GetBaseData(param): Observable<AgencyBaseDataProperties> {
    return this.http.get<AgencyBaseDataProperties>(this.baseUrl + '/AgencyMaster/GetAgencyBaseData/' + param)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  GetBackSystemCustomers(): Observable<CustomerSaleOrder[]> {
    return this.http.get<CustomerSaleOrder[]>(this.backSystemUrl + '/SaleOrder/GetCustomersList')
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }

  GetAllAgencies(param, userId): Observable<Agencies_BranchesProperties[]> {
    return this.http.get<Agencies_BranchesProperties[]>(this.baseUrl + '/AgencyMaster/GetAllAgencies/' + param + "/" + userId)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  GetAgencyById(agencyId): Observable<AgencyMasterProperties> {
    return this.http.get<AgencyMasterProperties>(this.baseUrl + '/AgencyMaster/GetAgencyById/' + agencyId)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }

  CreateAgencyRights(agencyObj): Observable<ReturnToFrontPropertiesforAgency> {
    return this.http.post<ReturnToFrontPropertiesforAgency>(this.baseUrl + '/AgencyMaster/CreateAgencyRights', agencyObj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  UpdateAgencyRights(agencyObj): Observable<ReturnToFrontPropertiesforAgency> {
    return this.http.post<ReturnToFrontPropertiesforAgency>(this.baseUrl + '/AgencyMaster/UpdateAgencyRights', agencyObj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }

  GetAgencyRightsById(agencyId): Observable<AgencyRightsProperties> {
    return this.http.get<AgencyRightsProperties>(this.baseUrl + '/AgencyMaster/GetAgencyRightsById/' + agencyId)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }

  GetParentChildBranches(param): Observable<B2BActiveBranches[]> {
    return this.http.get<B2BActiveBranches[]>(this.baseUrl + '/BranchInformation/GetParentChildBranches/' + param)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }

  GetSuppliersByParent(parentId:string): Observable<AgencySupplierRightsdata> {
    return this.http.get<AgencySupplierRightsdata>(this.baseUrl + '/Suppliers/GetSuppliersByParent?parentId='+parentId)
      .pipe(map((data: any) => {
        // //console.log(data);
        return data;
      }), catchError(error => {  return throwError(error); }))
  }

  GetparentAgencyRights(param,user): Observable<AgencyRightsProperties> {
    return this.http.get<AgencyRightsProperties>(this.baseUrl + '/AgencyMaster/GetparentAgencyRights/' + param + '/' +user)
      .pipe(map((data: any) => {
        // //console.log(data);
        return data;
      }), catchError(error => {  return throwError(error); }))
  }
  GetLoginUserRights(userId): Observable<LoginUserRights> {
    return this.http.get<LoginUserRights>(this.baseUrl + '/Users/GetLoginUserRights/' + userId)
      .pipe(map((data: any) => {
        // //console.log(data);
        return data;
      }), catchError(error => {  return throwError(error); }))
  }

  CreateAgencySupplierRights(obj): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/Suppliers/CreateAgencySupplierRights', obj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => {
        //console.log(error);
        return throwError(error);
      }))
  }
  CanEditAgenciesRight(): Observable<boolean> {
    return this.http.get<boolean>(this.baseUrl + '/AgencyMaster/CanEditAgenciesRight')
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => {
        //console.log(error);
        return throwError(error);
      }))
  }
  CheckChildAgenciesLimit(param, isAgency): Observable<number> {
    return this.http.get<number>(this.baseUrl + '/AgencyMaster/CheckChildAgenciesLimit/' + param + "/" + isAgency)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }

  CheckUsersLimit(param, isAgency): Observable<number> {
    return this.http.get<number>(this.baseUrl + '/Users/CheckUsersLimit/' + param + "/" + isAgency)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  GetManagersByAgency_Branch(param, isAgency): Observable<ManagerProperties[]> {
    return this.http.get<ManagerProperties[]>(this.baseUrl + '/AgencyMaster/GetManagersByAgency_Branch/' + param + "/" + isAgency)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }

  CheckCreditLimitRightAgaintAgencyAndUserId(agencyId, userId): Observable<boolean> {
    return this.http.get<boolean>(this.baseUrl + '/AgencyMaster/CheckCreditLimitRightAgainstAgencyAndUserId/' + agencyId + "/" + userId)
      .pipe(map((data: any) => {
        //console.log(data);
        return data;
      }), catchError(error => {
        //console.log(error);
        return throwError(error);
      }))
  }
  checkAccountRightAgainstAgencyAndUserId(agencyId, userId): Observable<boolean> {
    return this.http.get<boolean>(this.baseUrl + '/Users/CheckAccountRightAgainstAgencyAndUserId/' + agencyId + "/" + userId)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => {
        //console.log(error);
        return throwError(error);
      }))
  }
  checkCurrencyRightAgainstAgencyAndUserId(agencyId, userId): Observable<boolean> {
    return this.http.get<boolean>(this.baseUrl + '/Users/CheckCurrencyRightAgainstAgencyAndUserId/' + agencyId + "/" + userId)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => {
        //console.log(error);
        return throwError(error);
      }))
  }

  
  GetAgencyBranchPendingCreditS(agencyId): Observable<AgencyBranchCreditProperties> {
    return this.http.get<AgencyBranchCreditProperties>(this.baseUrl + '/AgencyMaster/GetAgencyBranchPendingCreditC/' + agencyId)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }

  UserLimitCheck(agencyId, imidiatParent, userLimit): Observable<boolean> {
    return this.http.get<boolean>(this.baseUrl + '/AgencyMaster/AgencyUsersLimit?agencyId=' + agencyId + '&imidiatParent=' + imidiatParent + '&userLimit=' + userLimit)
      .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }

  GetManagerByAgencyIdS(id): Observable<ManagerDetailsProperties> {
    return this.http.get<ManagerDetailsProperties>(this.baseUrl + '/AgencyMaster/GetManagerByAgencyIdC/' + id)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  TicketIssuanceCreditDeduction(agencyCreditObj): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/AgencyMaster/TicketCreditDeduction', agencyCreditObj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }

  UpdateAgencyStatus(param, isAgency): Observable<boolean> {
    return this.http.get<number>(this.baseUrl + '/AgencyMaster/UpdateAgencyStatus/' + isAgency + "/" + param )
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  GetAllReportTypes(): Observable<ReportTypesAgency[]> {
    return this.http.get<ReportTypesAgency[]>(this.baseUrl + '/AgencyMaster/GetAllReportTypes')
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  CreateBackSystemInfo(obj): Observable<branchBackFromServerProperties> {
    return this.http.post<branchBackFromServerProperties>(this.baseUrl + '/BranchInformation/CreateBranchSystemBackOffice', obj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => {
        //console.log(error);
        return throwError(error);
      }))
  }

  GetCheckLoginNameAvaliability(param): Observable<boolean> {
    return this.http.get<boolean>(this.baseUrl + '/BranchInformation/GetloginNameForAdminUser/' + param)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  CreateUpdateManagers(obj): Observable<agencyBackFromServerProperties> {
    return this.http.post<agencyBackFromServerProperties>(this.baseUrl + '/AgencyMaster/CreateManagersNew', obj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => {
        //console.log(error);
        return throwError(error);
      }))
  }

  //----------25-05-23 changes..................................
  GetCustomerCodeByID(param): Observable<CustomerCodes[]> {
    return this.http.post<CustomerCodes[]>(this.baseUrl + '/ERPBackOffice/CustomerCodes', param, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  GetBackSystemByid(branchId): Observable<BackSystemAllList[]> {
    return this.http.get<BackSystemAllList[]>(this.baseUrl + '/BranchInformation/GetBackSystemByID/' + branchId)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  DeleteManager(managerId): Observable<boolean> {
    return this.http.get<boolean>(this.baseUrl + "/AgencyMaster/DeleteManager?managerId=" + managerId)
      .pipe(map(data => {
        return data;
      }), catchError(error => {
        return throwError(error);
      }))
  }
  AgencyBranchLimitationRights(newAgencyId): Observable<boolean> {
    return this.http.get<boolean>(this.baseUrl + "/AgencyMaster/AgencyBranchLimitationRights?newAgencyId=" + newAgencyId)
      .pipe(map(data => {
        return data;
      }), catchError(error => {
        return throwError(error);
      }))
  }
  GetUsersByParent(param, isAgency, agencyId): Observable<ParentUsers[]> {
    return this.http.get<ParentUsers[]>(this.baseUrl + '/AgencyMaster/GetUsersByParent/' + param + "/" + isAgency + "/" + agencyId)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }

  //---------------------------------- 25-05-2023 This Section Is Just Updated To Test Parent Baranch Data ------------------------------//
  GetAgencyBaseDataForBranch(param): Observable<Agency_Branches[]> {
    return this.http.get<Agency_Branches[]>(this.baseUrl + '/AgencyMaster/GetAgencyBaseDataForBranch?param=' + param)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  getCountries(): Observable<Countries[]> {
    return this.http.get<Countries[]>(this.baseUrl + '/PassengerInfo/GetAllCountries')
      .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  getCities(): Observable<CitiesWithManagerCode[]> {
    return this.http.get<CitiesWithManagerCode[]>(this.baseUrl + '/PassengerInfo/GetAllCitiesWithManagerCode')
      .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  AgencyListBaseData(userId): Observable<AgencyListBaseData> {
    return this.http.get<boolean>(this.baseUrl + '/AgencyMaster/AgencyListBaseData?userId=' + userId)
      .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }


  GetAllAgenciesForList(param, userId): Observable<Agencies_BranchesProperties[]> {
    return this.http.get<Agencies_BranchesProperties[]>(this.baseUrl + '/AgencyMaster/GetAllAgenciesForList/' + param + "/" + userId)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  GetBaseDataForAgencyMaster(param): Observable<AgencyBaseDataProperties> {
    return this.http.get<AgencyBaseDataProperties>(this.baseUrl + '/AgencyMaster/GetBaseDataForAgencyMaster/' + param)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  AgencyBranchChildLimitationRights(agencyId): Observable<boolean> {
    return this.http.get<boolean>(this.baseUrl + "/AgencyMaster/AgencyBranchChildLimitationRights?agencyId=" + agencyId)
      .pipe(map(data => {
        return data;
      }), catchError(error => {
        return throwError(error);
      }))
  }


  CheckParentCreditLimit(param, isAgency, agencyId): Observable<CreditLimitChecking> {
    return this.http.get<CreditLimitChecking>(this.baseUrl + '/AgencyMaster/CheckParentCreditLimit/' + param + "/" + isAgency + "/" + agencyId)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }


  GetUsersForManagers(agencyBranchId): Observable<ParentUsers[]> {
    return this.http.get<ParentUsers[]>(this.baseUrl + '/AgencyMaster/GetUsersForManagers?agencyBranchId=' + agencyBranchId)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  GetAgenciesForManagers(userId, loginAgency): Observable<AgenciesForManagers[]> {
    return this.http.get<AgenciesForManagers[]>(this.baseUrl + '/AgencyMaster/GetAgenciesForManagers?userId=' + userId + '&&loginAgency=' + loginAgency)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  GetAgenciesForSupplierManagers(userId, loginAgency): Observable<AgenciesForManagers[]> {
    return this.http.get<AgenciesForManagers[]>(this.baseUrl + '/AgencyMaster/GetAgenciesForSupplierManagers?userId=' + userId + '&&loginAgency=' + loginAgency)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  //AddNewManagers(managers): Observable<boolean> {
  //  return this.http.post<boolean>(this.baseUrl + '/AgencyMaster/AddNewManagers', managers)
  //    .pipe(map((data: any) => {
  //      return data;
  //    }), catchError(error => { return throwError(error); }))
  //}



  GetCompanyMaster(): Observable<CompanyMasterProperties[]> {
    return this.http.get<CompanyMasterProperties[]>(this.baseUrl + '/CompanyMaster/GetCompanyMasterForAgencies').pipe(map((data: CompanyMasterProperties[]) => {
      return data;
    }), catchError(error => { return throwError(error) }))
  }
  GetBackSystemCredit(backSystemCreditRequest:BackSystemCreditRequest):Observable<BackSystemCreditLimitProperties>{
    return this.http.post<BackSystemCreditLimitProperties>(this.baseUrl+'/ERPBackOffice/GetCreditLimit',backSystemCreditRequest)
    .pipe(map((data:BackSystemCreditLimitProperties)=>{
      return data;
    }),catchError(error=>{
       return throwError(error);
    }))
  }

  GetParentBackSystemCompanies=(parentId:string):Observable<ParentBackSystemCompanies>=>{
    return this.http.get<ParentBackSystemCompanies>(this.baseUrl+'/BranchInformation/GetParentBackSystemCompanies?parentId='+parentId)
    .pipe(map((data:ParentBackSystemCompanies)=>{
      return data;
    }),catchError(error=>{
      return throwError(error);
    }))
  }
  AddNewManagers(managers: AddNewManagers): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/AgencyMaster/AddNewManagers', managers)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  RemovingManagers(managers: AddNewManagers): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/AgencyMaster/RemovingManagers', managers)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  //New Added
  CheckUserEmailValidation(email: string, userId: number): Observable<boolean> {
    return this.http.get<boolean>(this.baseUrl + '/BranchInformation/CheckEmailValidation?userEmail=' + email + '&userId=' + userId)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }

  GetAllUsersFromParentBranchChildAgenciesForStatus(agencyId): Observable<UserStatisticsProps> {
    return this.http.get<UserStatisticsProps>(this.baseUrl + '/Users/GetAllUsersFromParentBranchChildAgenciesForStatus/' + agencyId)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  GetUserRoleName(userId: number): Observable<string> {
    return this.http.get(this.baseUrl + '/Users/GetUserRoleName/' + userId, {
      responseType: 'text'
    });
  }

  //NewManagers(managers: AddNewManagers): Observable<boolean> {
  //  return this.http.post<boolean>(this.baseUrl + '/AgencyMaster/NewManagers', managers, this.httpOptions)
  //    .pipe(map((data: any) => {
  //      console.log(data)
  //      return data;

  //    }), catchError(error => { return throwError(error); }))
  //}
}
